
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules",
      function () {
        return require("private-next-pages/rules.tsx");
      }
    ]);
  